import { Injectable, EventEmitter, Output, TemplateRef } from '@angular/core';
import {NzMessageService, NzModalService, isTemplateRef} from 'ng-zorro-antd';
import {HttpService} from '../http/http-service.service';
import { NzDrawerRef, NzDrawerService, NzDrawerOptions } from 'ng-zorro-antd/drawer';
@Injectable({
  providedIn: 'root'
})
export class CommonService {
  @Output() deleteCallback: EventEmitter<any> =  new EventEmitter();
  @Output() afterCloseCallback: EventEmitter<any> = new EventEmitter();
  loading = false;
  modal: any;

  constructor(
    private messageService: NzMessageService,
    private modalService: NzModalService,
    private httpService: HttpService,
    private drawerService: NzDrawerService
  ) { }

  childrenOptions: any = [];
  // 刷新表格
  refreshTabl(tableObj, clear?) {
    const copyObj = JSON.parse(JSON.stringify(tableObj));
    if (clear) {
      copyObj.data = [];
      copyObj.params = {};
    } else {
      copyObj.data = tableObj.data;
    }
    copyObj.defaultLoad = !clear;
    tableObj = copyObj;
    return tableObj;
  }

  // 用于获取编辑单元格，表格数据
  formatTableData(arr) {
    const result = [];
    const obj = {
      string: value => value, float: value => parseFloat(value), date: value => value,
      checkBox: value => value
    };
    if (arr.length) {
      arr.forEach((item) => {
        const temp = {};
        const showFormatter = {};
        item.forEach((c) => {
          if (c.name === 'propertyName' || c.name === 'showName') {
            Object.defineProperty(temp, c.name, {value: obj[c.type](c.value), enumerable: true});
          } else {
            if (!c.others) {
              if (c.type === 'float') {
                Object.defineProperty(showFormatter, c.name, {value: obj[c.type](c.value) || 0, enumerable: true});
              }
              if (c.type === 'checkBox') {
                Object.defineProperty(showFormatter, c.name, {value: obj[c.type](c.value) || false, enumerable: true});
              }
              Object.defineProperty(showFormatter, c.name, {value: obj[c.type](c.value), enumerable: true});
            } else {
              if (c.others.type === 'checkBox') {
                Object.defineProperty(showFormatter, c.name, {value: c.others.value, enumerable: true});
              }
              if (c.others.type === 'select') {
                if (c.others.value) {
                  Object.defineProperty(showFormatter, c.name, {value: c.others.selectedValue.value, enumerable: true});
                }
              }
            }
            Object.defineProperty(temp, 'showFormatter', {value: showFormatter, enumerable: true});
          }
        });
        result.push(temp);
      });
    }
    if (result.length) {
      const a = [];
      result.forEach((r) => {
        a.push(r.showFormatter.num);
      });
      if (this.isRepeat(a)) {
        this.messageService.error('序号不能相同');
        return;
      } else {

      }
    }
    return result;
  }

  // 判断是否重复
  isRepeat(arr) {
    const hash = {};
    // tslint:disable-next-line:forin
    for (const i in arr) {
      if (hash[arr[i]]) {
        return true;
      }
      hash[arr[i]] = true;
    }
    return false;
  }
  
  isNull(tag) {
    if (tag === undefined || tag === null || tag === '') {
      return false;
    } else {
      return true;
    }
  }

  setChildrenOptionParams(e, list) {
    const children = e.children.split(',');
    list.forEach(p => {
      children.forEach((c, index) => {
        if (p.id === c) {
          p.params[e.key] = e.value;
        }
      });
    });
  }

  // deleteData( url, parmas, content?: string) {
  //   this.modalService.confirm({
  //     nzTitle: '删除数据',
  //     nzContent:  '<b style="color: red;">' + content + '</b>',
  //     nzOkText: '确定',
  //     nzOkType: 'danger',
  //     nzOkLoading: this.loading,
  //     nzOnOk: () => this.delete(url, parmas),
  //     nzCancelText: '取消',
  //     nzOnCancel: () => console.log('Cancel')
  //   });
  // }

  // delete(url, parmas) {
  //   this.loading = true;
  //   this.httpService.httpDelete(url, parmas).subscribe(res => {
  //     if (res.code === 1) {
  //       this.loading = false;
  //       this.messageService.success('删除成功');
  //       this.deleteCallback.emit();
  //     }
  //   });
  // }

  createModal(modalItem: {type?: string, title: any, params?: any, content: any, footer?: any, style?: any, node?: any}) {
    let modal: any;
    let width = document.body.clientWidth * 0.8;
    let height = document.body.clientHeight * 0.9;
    let bodyHeight = 55;
    if (modalItem.footer) {
      bodyHeight = 110;
    }
    if (modalItem.style && modalItem.style.width) {
      width = modalItem.style.width;
    }
    if (modalItem.style && modalItem.style.height) {
      height = modalItem.style.height;
    }
    const style = {
      position: 'absolute',
      top: '50%', left: '50%', bottom: 0, right: 0,
      height: `${height}px`, width: `${width}px`,
      'min-height': `${height}px`, 'max-height': `${height}px`,
      'margin-top': -(height) / 2 + 'px', 'margin-left': -(width) / 2 + 'px'
    };

    if (modalItem.type === 'drawer') {
      modal = this.drawerService.create({
        nzTitle: modalItem.title,
        nzContent: modalItem.content,
        nzContentParams: modalItem.params || null,
        // nzFooter: modalItem.footer || null,
        nzMaskClosable: false,
        nzWidth: `${width}px`,
        // nzStyle: style,
        // nzGetContainer: modalItem.node,
        nzBodyStyle: {height: `${height - 500}px`, width: '100%', 'overflow-y': 'auto'}
        // nzContentParams: {
        //   value: this.value
        // }
      });
    } else if (modalItem.type === 'modal') {
        modal = this.modalService.create({
        nzTitle: modalItem.title,
        nzContent: modalItem.content,
        nzFooter: modalItem.footer || null,
        nzMaskClosable: false,
        nzStyle: style,
        nzGetContainer: modalItem.node,
        nzBodyStyle: {height: `${height - bodyHeight}px`, width: '100%', 'overflow-y': 'auto'}
      });
    }
    return modal;
  }
  destory(modal) {
    modal.destory();
  }

  downLoad(url, type, params?) {
    const headerBody = {
      method: type,
      headers: new Headers({
        'Content-Type': 'application/json;charset=UTF-8',
      })
    };
    if (type === 'POST') {
      headerBody['body'] = JSON.stringify(params);
    }
    fetch(url, headerBody).then(response => {
        const res = new Response(response.body);
        const contentType = response.headers.get('Content-Type');
        if (contentType.includes('application/json')) {
          res.json().then(i => {
            if (i.code && i.code === 2) {
              return this.messageService.error(i.message);
            } else {
            }
          });
          return;
        }
        response.blob().then(blob => {
          const disposition = response.headers.get('Content-Disposition');
          if (!disposition) {
            return;
          }
          const fileName = disposition.split(';')[1].split('=')[1];
          const blobUrl = window.URL.createObjectURL(blob);
          const aElement = document.createElement('a');
          aElement.download = decodeURI(fileName);
          document.body.appendChild(aElement);
          aElement.style.display = 'none';
          aElement.href = blobUrl;
          aElement.click();
          document.body.removeChild(aElement);
        });
      });
  }
}
